/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import ActionButton from 'components/ActionButton'
import {
  ModalActions,
  ModalCard,
  ModalMessage,
  ModalOverlay,
  ModalTitle
} from 'components/modals/styles'
import { setAssessments } from 'app/reducer/assessmentSlice'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { QuestionnaireContext } from '../QuestionnaireContext'
import PauseConfirmationModal from './pauseConfirmationModal'

const Overlay = styled(ModalOverlay)`
  z-index: 10010;
`

const Card = styled(ModalCard)`
  width: 500px;
  max-width: 800px;
  border-radius: 8px;
`

const Header = styled.div`
  margin-bottom: 10px;
`

const Body = styled.div`
  margin-bottom: 14px;
`

const PauseExitModal: FC<{}> = () => {
  const {
    setIsPaused,
    showPauseExitModal,
    setShowPauseExitModal,
    isPaused,
    onExit,
    audioRef,
    setKeyToSpeak,
    keyToSpeak
  } = useContext(QuestionnaireContext)

  const [showConfirmation, setShowConfirmation] = useState<boolean>(false)

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const onExiting = () => {
    onExit()
    navigate('/classroom')
    setShowPauseExitModal(false)
    dispatch(setAssessments([]))
  }

  const handlePress = (event: any) => {
    if (event.keyCode === 27) {
      setShowPauseExitModal(false)
      keyToSpeak && audioRef.current?.play()
    }
  }

  const onPauseTest = () => {
    const element = document.getElementById(keyToSpeak)
    element?.classList.remove('playtts')
    setKeyToSpeak(null!)

    setIsPaused(true)
    setShowPauseExitModal(false)
    setShowConfirmation(true)
  }

  const onResumeTest = () => {
    setIsPaused(false)
    setShowConfirmation(false)
  }

  const onCancel = () => {
    setShowPauseExitModal(false)
    keyToSpeak && audioRef.current?.play()
  }

  useEffect(() => {
    showPauseExitModal &&
      document.addEventListener('keydown', handlePress, false)

    return () => {
      document.removeEventListener('keydown', handlePress, false)
    }
  }, [showPauseExitModal])

  return (
    <>
      {isPaused && <div className='mainContent-backDrop'></div>}
      {showPauseExitModal && (
        <Overlay onClick={onCancel}>
          <Card
            role='dialog'
            aria-modal='true'
            aria-labelledby='pause-exit-modal-title'
            onClick={(event) => event.stopPropagation()}
          >
            <Header>
              <ModalTitle id='pause-exit-modal-title'>
                Do you want to pause your test or exit your test?
              </ModalTitle>
            </Header>
            <Body>
              <ModalMessage>
                Pause the test to temporarily logout. Exit the test to logout
                and close the testing application.
              </ModalMessage>
            </Body>
            <ModalActions>
              <ActionButton
                label='Cancel'
                variant='clear'
                width={92}
                onClick={onCancel}
              />
              <ActionButton
                label='Pause'
                variant='warn'
                width={92}
                onClick={onPauseTest}
              />
              <ActionButton
                label='Exit'
                variant='error'
                width={92}
                onClick={onExiting}
              />
            </ModalActions>
          </Card>
        </Overlay>
      )}
      <PauseConfirmationModal show={showConfirmation} onClose={onResumeTest} />
    </>
  )
}

export default PauseExitModal
